import Icon from '../components/Icon.vue'

Icon.register({
  ring: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 64c145.9 0 256 61.9 256 144v98.1c0 78.4-114.6 141.9-256 141.9s-256-63.5-256-141.9v-98.1c0-82.1 110.1-144 256-144zM256 128c-106 0-192 35.8-192 80 0 9.3 4 18.1 10.9 26.4 44.9-26.2 108.9-42.4 181.1-42.4s136.2 16.2 181.1 42.4c6.9-8.3 10.9-17.1 10.9-26.4 0-44.2-86-80-192-80zM120.4 264.6c34.7 14.4 82.6 23.4 135.6 23.4s100.8-8.9 135.6-23.4c-34.6-14.7-81.2-24.6-135.6-24.6s-101 9.9-135.6 24.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ring.js
// module id = 1842
// module chunks = 0